import React from 'react';
import { mdiContentCopy } from '@mdi/js';
import copyToClipboard from 'common/utils/copyToClipboard';
import Ninja from '@ninja';
import { NameFormatter } from 'components/tables/NinjaTable/formatters';
import TableIcons from 'components/table-formatters/TableIcons/TableIcons';

const PathFormatter = ({ row }) => {
  const path = row?.path;

  if (!path) return '-';

  const copyPath = (e) => {
    e.stopPropagation();
    copyToClipboard(path);
  };

  const icons = [
    {
      icon: mdiContentCopy,
      onClick: copyPath,
      tooltip: 'Copy Path',
      onlyOnHover: true,
      show: path,
    },
  ];

  return (
    <div className='gap-2 flex justify-between text-left w-40 text-xs bg-background-light p-1.5 rounded-md items-center h-8 truncate'>
      <NameFormatter name={path} />
      <TableIcons color={Ninja.colors.light} icons={icons} />
    </div>
  );
};

export default PathFormatter;
